import { create } from "zustand";

interface CropperActions {
  dispatch: any;
  clear: any;
  action: object|null;
  prevAction: object|null;
};

export const useCropperAction = create((set: any, get: any) : CropperActions => ({
  action: null,
  prevAction: null,
  clear() {
    set({action: null, prevAction: get().action });
  },
  dispatch(action: object) {
    // console.log('dispatch', action);
    set({ action });
  },
}));